import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../../../../../actions/utilAction';
// import { create } from 'domain';

export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const GET_PATIENT_SKILL_ACQ_ACTIVE_PROGRAMS_LIST_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetPatientSkillAcqActivePrograms`;


export const PatientSkillAcqActiveProgramListActionTypes = {
    get_patientSkillAcqActiveProgramList: createRequestActionTypes('GET_PATIENT_SKILL_ACQ_ACTIVE_PROGRAMS_LIST_API'),
    set_uuid: createRequestActionTypes('SET_UUID'),
    set_openTarget: createRequestActionTypes('SET_OPEN_TARGET'),
    set_ProgramIds: createRequestActionTypes('SET_PROGRAMIDS'),
    reset_ProgramAndtarget: createRequestActionTypes('RESET_PROGRAMANDTARGET'),
    set_ProgramForSKillAxqTargetApplicationState: createRequestActionTypes('SET_PROGRAMFOR_SKILLACQ_TARGET_APPLICATION_STATE')
};

export const MODULE = 'DCPATIENT_SKILLAQUISITIONPROGRAM';


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Maintenance/components/programs/constants/ApiConstants.js